module.exports = __webpack_public_path__ + "static/media/Salons.a1f10fe9.svg";